export default __webpack_public_path__ + "static/media/close.1a2de9f9.svg";